export const PermissionUser = {
  // Settings
  SETTINGS_READ: "settings:read",
  SETTINGS_WRITE: "settings:write",

  // M1
  WPM: {
    DASHBOARD_READ: "wpm.dashboard.technical:read",

    EXCECUTIVE_DASHBOARD_READ: "wpm.dashboard.executive:read",

    TICKET_READ: "wpm.ticket:read",
    TICKET_WRITE: "wpm.ticket:write",
    TICKET_DELETE: "wpm.ticket:delete",

    TICKET_ESCALATION_READ: "wpm.ticket.escalation:read",
    TICKET_ESCALATION_WRITE: "wpm.ticket.escalation:write",
    TICKET_ESCALATION_DELETE: "wpm.ticket.escalation:delete",

    TICKET_ALL_DEPARTMENT_READ: "wpm.ticket.all_departments:read",

    SITE_ACCESS_READ: "wpm.site_access:read",
    SITE_ACCESS_WRITE: "wpm.site_access:write",
    SITE_ACCESS_DELETE: "wpm.site_access:delete",
    SITE_ACCESS_DASHBOARD_READ: "wpm.dashboard.site_access:read",

    NTDC_CONTRACT_READ: "wpm.contract:read",
    NTDC_CONTRACT_WRITE: "wpm.contract:write",
    NTDC_CONTRACT_DELETE: "wpm.contract:delete",
    NTDC_CONTRACT_APPROVAL_WRITE: "wpm.contract.approval:write",

    NTDC_CUSTOMER_READ: "wpm.customer:read",
    NTDC_CUSTOMER_WRITE: "wpm.customer:write",

    NTDC_CONTACT_POINT_READ: "wpm.contact_point:read",
    NTDC_CONTACT_POINT_WRITE: "wpm.contact_point:write",

    NTDC_ATTACHMENT_READ: "wpm.contract.attachment:read",
    NTDC_ATTACHMENT_DELETE: "wpm.contract.attachment:delete",

    IPAM_READ: "wpm.ipam:read",
    IPAM_WRITE: "wpm.ipam:write",
    IPAM_DELETE: "wpm.ipam:delete",

    REPORT_TICKET_READ: "wpm.report.ticket:read",
    REPORT_SITE_ACCESS_READ: "wpm.report.site_access:read",
    REPORT_NTDC_CONTRACT_READ: "wpm.report.contract:read",
    REPORT_IPAM_READ: "wpm.report.ipam:read",
    REPORT_WORKLOAD_READ: "wpm.report.workload:read",

    WORKLOAD_READ: "wpm.workload:read",
    WORKLOAD_ALL_USERS_READ: "wpm.workload.all_users:read",

    // SMART_HAND_READ: "wpm.smart_hand:read",
    // SMART_HAND_WRITE: "wpm.smart_hand:write",
    // CROSS_CONNECT_READ: "wpm.cross_connect:read",
    // PARCEL_TRACKING_READ: "wpm.parcel_tracking:read",
    // INVENTORY_READ: "wpm.inventory:read",
    // INVENTORY_WRITE: "wpm.inventory:write",
  },

  // M2
  SMS: {
    DASHBOARD_READ: "sms.dashboard:read",

    ALL_EVENTS_READ: "sms.event:read",

    SERVER_MANAGEMENT_READ: "sms.server:read",
    SERVER_MANAGEMENT_WRITE: "sms.server:write",

    ALERT_READ: "sms.alert:read",
    ALERT_WRITE: "sms.alert:write",

    REPORT_READ: "sms.report:read",

    DISCOVERY_READ: "sms.discovery:read",

    POLICY_READ: "sms.policy:read",
    POLICY_WRITE: "sms.policy:write",
  },

  // M3
  BMM: {
    DASHBOARD_READ: "bmm.dashboard:read",

    SERVER_MANAGEMENT_READ: "bmm.server:read",
    SERVER_MANAGEMENT_WRITE: "bmm.server:write",

    REPOSITORY_READ: "bmm.repository:read",
    REPOSITORY_WRITE: "bmm.repository:write",

    BACKUP_READ: "bmm.backup:read",
    BACKUP_WRITE: "bmm.backup:write",

    CREDENTIAL_READ: "bmm.credential:read",
    CREDENTIAL_WRITE: "bmm.credential:write",

    VEEAM_READ: "bmm.veeam:read",
    VEEAM_WRITE: "bmm.veeam:write",
  },

  // M4
  NCM: {
    DASHBOARD_READ: "ncm.dashboard:read",

    NODE_MANAGEMENT_READ: "ncm.node:read",
    NODE_MANAGEMENT_WRITE: "ncm.node:write",

    CONFIG_HISTORY_READ: "ncm.config_history:read",

    CONFIG_TEMPLATE_READ: "ncm.config_template:read",
    CONFIG_TEMPLATE_WRITE: "ncm.config_template:write",

    CONFIG_COMPARISON_READ: "ncm.config_comparison:read",

    DISCOVERY_NODE_READ: "ncm.node_discovery:read",

    CREDENTIAL_READ: "ncm.credential:read",
    CREDENTIAL_WRITE: "ncm.credential:write",

    BACKUP_SETTINGS_READ: "ncm.backup_config:read",
    BACKUP_SETTINGS_WRITE: "ncm.backup_config:write",
  },
}

export const routePermissions = {
  // Settings
  globalSettings: [PermissionUser.SETTINGS_READ, PermissionUser.SETTINGS_WRITE],

  customerPermission: [
    PermissionUser.SETTINGS_READ,
    PermissionUser.SETTINGS_WRITE,
  ],

  serviceManagement: [
    PermissionUser.SETTINGS_READ,
    PermissionUser.SETTINGS_WRITE,
  ],
  createNewService: [PermissionUser.SETTINGS_WRITE],
  serviceDetail: [PermissionUser.SETTINGS_READ, PermissionUser.SETTINGS_WRITE],

  addTicketTopicData: [
    PermissionUser.SETTINGS_READ,
    PermissionUser.SETTINGS_WRITE,
  ],
  addTicketReplyTemplateData: [
    PermissionUser.SETTINGS_READ,
    PermissionUser.SETTINGS_WRITE,
  ],
  locationManagement: [
    PermissionUser.SETTINGS_READ,
    PermissionUser.SETTINGS_WRITE,
  ],
  locationDetail: [PermissionUser.SETTINGS_WRITE],

  // WPM M1
  internalPortalDashboard: [PermissionUser.WPM.DASHBOARD_READ],

  internalPortalExecutiveDashboard: [
    PermissionUser.WPM.EXCECUTIVE_DASHBOARD_READ,
  ],

  internalTicketManagement: [PermissionUser.WPM.TICKET_READ],
  internalTicketDetail: [
    PermissionUser.WPM.TICKET_READ,
    PermissionUser.WPM.TICKET_WRITE,
  ],
  internalCreateNewTicket: [PermissionUser.WPM.TICKET_WRITE],
  internalCreateNewIncident: [PermissionUser.WPM.TICKET_WRITE],

  escalationTemplate: [PermissionUser.WPM.TICKET_ESCALATION_READ],
  escalationTemplateDetail: [
    PermissionUser.WPM.TICKET_ESCALATION_READ,
    PermissionUser.WPM.TICKET_ESCALATION_WRITE,
  ],
  createEscalationTemplate: [PermissionUser.WPM.TICKET_ESCALATION_WRITE],
  editEscalationTemplate: [PermissionUser.WPM.TICKET_ESCALATION_WRITE],

  escalationEvents: [PermissionUser.WPM.TICKET_ESCALATION_READ],
  // May not be used
  escalationTemplateHistory: [PermissionUser.WPM.TICKET_ESCALATION_READ],

  internalSiteAccessDashboard: [PermissionUser.WPM.SITE_ACCESS_DASHBOARD_READ],
  internalSiteAccessManagement: [PermissionUser.WPM.SITE_ACCESS_READ],
  internalSiteAccessDetail: [
    PermissionUser.WPM.SITE_ACCESS_READ,
    PermissionUser.WPM.SITE_ACCESS_WRITE,
  ],
  internalCreateNewSiteAccess: [PermissionUser.WPM.SITE_ACCESS_WRITE],

  internalIdc: [PermissionUser.WPM.NTDC_CONTRACT_READ],
  idcContractAction: [
    PermissionUser.WPM.NTDC_CONTRACT_READ,
    PermissionUser.WPM.NTDC_CONTRACT_WRITE,
  ],
  idcCreateNewContract: [PermissionUser.WPM.NTDC_CONTRACT_WRITE],

  idcCustomer: [PermissionUser.WPM.NTDC_CUSTOMER_READ],
  idcEditCustomer: [
    PermissionUser.WPM.NTDC_CUSTOMER_READ,
    PermissionUser.WPM.NTDC_CUSTOMER_WRITE,
  ],
  idcCreateCustomer: [PermissionUser.WPM.NTDC_CUSTOMER_WRITE],

  idcContact: [PermissionUser.WPM.NTDC_CONTACT_POINT_READ],
  idcCreateContactPointOrSale: [PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE],
  idcEditContactPointOrSale: [
    PermissionUser.WPM.NTDC_CONTACT_POINT_READ,
    PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE,
  ],

  internalPortalAttachmentManagement: [PermissionUser.WPM.NTDC_ATTACHMENT_READ],

  ipamManagement: [PermissionUser.WPM.IPAM_READ],

  webPortalReport: [
    PermissionUser.WPM.REPORT_TICKET_READ,
    PermissionUser.WPM.REPORT_SITE_ACCESS_READ,
    PermissionUser.WPM.REPORT_NTDC_CONTRACT_READ,
    PermissionUser.WPM.REPORT_IPAM_READ,
    PermissionUser.WPM.REPORT_WORKLOAD_READ,
  ],

  internalWebPortalWorkload: [
    PermissionUser.WPM.WORKLOAD_READ,
    PermissionUser.WPM.WORKLOAD_ALL_USERS_READ,
  ],

  // internalInventory: [
  //   PermissionUser.WPM.INVENTORY_READ,
  //   PermissionUser.WPM.INVENTORY_WRITE,
  // ],
  // internalSmartHand: [PermissionUser.WPM.SMART_HAND_READ],
  // internalSmartHandCreate: [PermissionUser.WPM.SMART_HAND_WRITE],
  // internalSmartHandDetail: [
  //   PermissionUser.WPM.SMART_HAND_READ,
  //   PermissionUser.WPM.SMART_HAND_WRITE,
  // ],
  // internalParcelTracking: [PermissionUser.WPM.PARCEL_TRACKING_READ],
  // internalCrossConnect: [PermissionUser.WPM.CROSS_CONNECT_READ],
  // internalCrossConnectDetail: [PermissionUser.WPM.CROSS_CONNECT_READ],

  // SMS M2
  serverManagementDashboard: [PermissionUser.SMS.DASHBOARD_READ],

  serverManagementAllEvents: [PermissionUser.SMS.ALL_EVENTS_READ],

  serverManagementServerManagement: [PermissionUser.SMS.SERVER_MANAGEMENT_READ],
  serverManagementServerManagementDetail: [
    PermissionUser.SMS.SERVER_MANAGEMENT_READ,
    PermissionUser.SMS.SERVER_MANAGEMENT_WRITE,
  ],

  serverManagementAlert: [PermissionUser.SMS.ALERT_READ],
  createAlert: [PermissionUser.SMS.ALERT_WRITE],
  editAlert: [PermissionUser.SMS.ALERT_WRITE],

  serverManagementReport: [PermissionUser.SMS.REPORT_READ],

  serverManagementDiscovery: [PermissionUser.SMS.DISCOVERY_READ],

  serverManagementPolicy: [PermissionUser.SMS.POLICY_READ],
  createPolicy: [PermissionUser.SMS.POLICY_WRITE],
  editPolicy: [PermissionUser.SMS.POLICY_WRITE],

  // BMM M3
  backupManagementDashboard: [PermissionUser.BMM.DASHBOARD_READ],

  backupManagementServerManagement: [PermissionUser.BMM.SERVER_MANAGEMENT_READ],

  backupManagementRepository: [PermissionUser.BMM.REPOSITORY_READ],

  backupManagementBackup: [PermissionUser.BMM.BACKUP_READ],
  backupManagementCreateNewBackup: [PermissionUser.BMM.BACKUP_WRITE],
  backupManagementDetailBackup: [
    PermissionUser.BMM.BACKUP_READ,
    PermissionUser.BMM.BACKUP_WRITE,
  ],

  backupManagementCredential: [PermissionUser.BMM.CREDENTIAL_READ],

  backupManagementVeeam: [PermissionUser.BMM.VEEAM_READ],

  // NCM M4
  networkConfigurationDashboard: [PermissionUser.NCM.DASHBOARD_READ],
  networkConfigurationNodeManagement: [PermissionUser.NCM.NODE_MANAGEMENT_READ],
  networkConfigurationNodeManagementDetail: [
    PermissionUser.NCM.NODE_MANAGEMENT_READ,
    PermissionUser.NCM.NODE_MANAGEMENT_WRITE,
  ],

  networkConfigurationConfigurationHistory: [
    PermissionUser.NCM.CONFIG_HISTORY_READ,
  ],

  networkConfigurationConfigurationTemplate: [
    PermissionUser.NCM.CONFIG_TEMPLATE_READ,
  ],
  networkConfigurationCreateNewConfigurationTemplate: [
    PermissionUser.NCM.CONFIG_TEMPLATE_WRITE,
  ],
  networkConfigurationConfigurationTemplateDetail: [
    PermissionUser.NCM.CONFIG_TEMPLATE_READ,
    PermissionUser.NCM.CONFIG_TEMPLATE_WRITE,
  ],
  networkConfigurationUseConfigurationTemplate: [
    PermissionUser.NCM.CONFIG_TEMPLATE_WRITE,
  ],
  networkConfigurationUseConfigurationTemplate: [
    PermissionUser.NCM.CONFIG_TEMPLATE_WRITE,
  ],

  networkConfigurationConfigurationComparison: [
    PermissionUser.NCM.CONFIG_COMPARISON_READ,
  ],

  networkConfigurationDiscovery: [PermissionUser.NCM.DISCOVERY_NODE_READ],

  networkConfigurationCredential: [PermissionUser.NCM.CREDENTIAL_READ],

  networkConfigurationBackupSettings: [PermissionUser.NCM.BACKUP_SETTINGS_READ],
  networkConfigurationBackupSettingsDetail: [
    PermissionUser.NCM.BACKUP_SETTINGS_READ,
    PermissionUser.NCM.BACKUP_SETTINGS_WRITE,
  ],
  networkConfigurationBackupSettingsCreateNewCommands: [
    PermissionUser.NCM.BACKUP_SETTINGS_WRITE,
  ],
}

export const routesPermissionAccessMenu = [
  // Settings
  {
    permission: routePermissions.globalSettings,
    path: "/global-settings",
    name: "globalSettings",
  },
  {
    permission: routePermissions.customerPermission,
    path: "/global-settings/customer-permission",
    name: "customerPermission",
  },
  {
    permission: routePermissions.serviceManagement,
    path: "/global-settings/data-management/service",
    name: "serviceManagement",
  },
  {
    permission: routePermissions.createNewService,
    path: "/global-settings/data-management/service/create",
    name: "createNewService",
  },
  {
    permission: routePermissions.serviceDetail,
    path: "/global-settings/data-management/service/:serviceId",
    name: "serviceDetail",
  },
  {
    permission: routePermissions.addTicketTopicData,
    path: "/global-settings/data-management/ticket-topic",
    name: "addTicketTopicData",
  },
  {
    permission: routePermissions.addTicketReplyTemplateData,
    path: "/global-settings/data-management/ticket-reply-template",
    name: "addTicketReplyTemplateData",
  },
  {
    permission: routePermissions.locationManagement,
    path: "/global-settings/data-management/location",
    name: "locationManagement",
  },
  {
    permission: routePermissions.locationDetail,
    path: "/global-settings/data-management/location/:siteId",
    name: "locationDetail",
  },

  // WPM M1
  {
    permission: routePermissions.internalPortalDashboard,
    path: "/internal/web-portal/dashboard",
    name: "internalPortalDashboard",
  },
  {
    permission: routePermissions.internalPortalExecutiveDashboard,
    path: "/internal/web-portal/executive-dashboard",
    name: "internalPortalExecutiveDashboard",
  },
  {
    permission: routePermissions.internalTicketManagement,
    path: "/internal/web-portal/ticket",
    name: "internalTicketManagement",
  },
  {
    permission: routePermissions.escalationTemplate,
    path: "/internal/web-portal/escalation/template",
    name: "escalationTemplate",
  },
  {
    permission: routePermissions.escalationEvents,
    path: "/internal/web-portal/escalation/events",
    name: "escalationEvents",
  },
  {
    permission: routePermissions.internalSiteAccessDashboard,
    path: "/internal/web-portal/site-access/dashboard",
    name: "internalSiteAccessDashboard",
  },
  {
    permission: routePermissions.internalSiteAccessManagement,
    path: "/internal/web-portal/site-access",
    name: "internalSiteAccessManagement",
  },
  {
    permission: routePermissions.internalIdc,
    path: "/internal/web-portal/idc",
    name: "internalIdc",
  },
  {
    permission: routePermissions.idcCustomer,
    path: "/internal/web-portal/idc/customer",
    name: "idcCustomer",
  },
  {
    permission: routePermissions.idcContact,
    path: "/internal/web-portal/idc/contact",
    name: "idcContact",
  },
  {
    permission: routePermissions.ipamManagement,
    path: "/internal/web-portal/ipam",
    name: "ipamManagement",
  },
  {
    permission: routePermissions.internalPortalAttachmentManagement,
    path: "/internal/web-portal/idc/attachment",
    name: "internalPortalAttachmentManagement",
  },
  {
    permission: routePermissions.webPortalReport,
    path: "/internal/web-portal/report",
    name: "webPortalReport",
  },
  {
    permission: routePermissions.internalWebPortalWorkload,
    path: "/internal/web-portal/workload",
    name: "internalWebPortalWorkload",
  },

  // SMS M2
  {
    permission: routePermissions.serverManagementDashboard,
    path: "/server-management/dashboard",
    name: "serverManagementDashboard",
  },
  {
    permission: routePermissions.serverManagementAllEvents,
    path: "/server-management/all-events",
    name: "serverManagementAllEvents",
  },
  {
    permission: routePermissions.serverManagementRead,
    path: "/server-management/server-management",
    name: "serverManagementServerManagement",
  },
  {
    permission: routePermissions.serverManagementAlert,
    path: "/server-management/alert",
    name: "serverManagementAlert",
  },
  {
    permission: routePermissions.serverManagementReport,
    path: "/server-management/report",
    name: "serverManagementReport",
  },
  {
    permission: routePermissions.serverManagementDiscovery,
    path: "/server-management/discovery",
    name: "serverManagementDiscovery",
  },
  {
    permission: routePermissions.serverManagementPolicy,
    path: "/server-management/policy",
    name: "serverManagementPolicy",
  },

  // BMM M3
  {
    permission: routePermissions.backupManagementDashboard,
    path: "/backup-management/dashboard",
    name: "backupManagementDashboard",
  },
  {
    permission: routePermissions.backupManagementServerManagement,
    path: "/backup-management/server-management",
    name: "backupManagementServerManagement",
  },
  {
    permission: routePermissions.backupManagementRepository,
    path: "/backup-management/repository",
    name: "backupManagementRepository",
  },
  {
    permission: routePermissions.backupManagementBackup,
    path: "/backup-management/backup",
    name: "backupManagementBackup",
  },
  {
    permission: routePermissions.backupManagementCredential,
    path: "/backup-management/credential",
    name: "backupManagementCredential",
  },
  {
    permission: routePermissions.backupManagementVeeam,
    path: "/backup-management/veeam",
    name: "backupManagementVeeam",
  },

  // NCM M4
  {
    permission: routePermissions.networkConfigurationDashboard,
    path: "/network-configuration/dashboard",
    name: "networkConfigurationDashboard",
  },
  {
    permission: routePermissions.networkConfigurationNodeManagement,
    path: "/network-configuration/node-management",
    name: "networkConfigurationNodeManagement",
  },
  {
    permission: routePermissions.networkConfigurationConfigurationHistory,
    path: "/network-configuration/configuration-history",
    name: "networkConfigurationConfigurationHistory",
  },
  {
    permission: routePermissions.networkConfigurationConfigurationTemplate,
    path: "/network-configuration/configuration-template",
    name: "networkConfigurationConfigurationTemplate",
  },
  {
    permission: routePermissions.networkConfigurationConfigurationComparison,
    path: "/network-configuration/configuration-comparison",
    name: "networkConfigurationConfigurationComparison",
  },
  {
    permission: routePermissions.networkConfigurationDiscovery,
    path: "/network-configuration/discovery",
    name: "networkConfigurationDiscovery",
  },
  {
    permission: routePermissions.networkConfigurationCredential,
    path: "/network-configuration/credential",
    name: "networkConfigurationCredential",
  },
  {
    permission: routePermissions.networkConfigurationBackupSettings,
    path: "/network-configuration/backup-settings",
    name: "networkConfigurationBackupSettings",
  },
]
